import Cookies from 'js-cookie';

function cookies() {
    return {
        // افزودن کوکی
        set: (name, value, days = 7) => {
            Cookies.set(name, value, { expires: days });
        },

        // دریافت مقدار کوکی
        get: (name) => {
            return Cookies.get(name);
        },

        // حذف کوکی
        remove: (name) => {
            Cookies.remove(name);
        },

        // بررسی وجود کوکی
        has: (name) => {
            return !!Cookies.get(name);
        }
    };
}

export default cookies;
